import request from './request';
import { setCustomerConfig, setSystemSettings, setUserSettings, getUserSettings } from './SettingsRetriever';

import EnvConfig from '../settings/current.json';

export default () => new Promise((resolve, reject) => {
    const url = window.location.hostname;
    const path = window.location.pathname.split('/').length > 1 ? '/' + window.location.pathname.split('/')[1] : '';
    const customers = EnvConfig.customers;
    let customerExists = false;

    if(customers.length < 1){
        reject('no destination found (0)');
    }

    customers.forEach((customer, idx) => {
        let ret = {};
        customer.urls.forEach((_url, jdx) => {
            if (_url === url + path || _url === url) {
                customerExists = true;
                Promise.all([
                    request({
                        url: 'https://s3.amazonaws.com/spotlio-react-booking-configurations/customers/' + customer.name + '/' + customer.stage + '.json',
                        method: 'GET'
                    }),
                    request({
                        url: EnvConfig.endpoint + '/api/programmatic/getreactconfig?apikey=a1e8ed6fa348a20bec841ffaf0e9957a251d8e5c4420&alias=' + customer.name,
                        method: 'GET'
                    })
                ]).then((resArr) => {
                    const customerConfig = resArr[0];
                    const result = resArr[1];
                    ret = { customer: customer, config: customerConfig.data };
                    let _path = _url.match(url + path) ? path : '';
                    const settings = {...result.data, urlPrefix: _path};
                    setCustomerConfig(ret);
                    setSystemSettings(settings);
                    if (!getUserSettings()) {
                        setUserSettings({
                            currencies: {
                                selected: settings.app.currency.default
                            }
                        });
                    }
                    resolve([ret, settings]);
                }).catch(() => reject('no destination found (1)'));
            }
            if ((idx + 1) === customers.length && (jdx + 1) === customer.urls.length && !customerExists) {
                reject('no destination found (2)');
            }
        })
    })
});
